<template lang="html">
  <!-- страница заведена в CMS (слаг `about`) — показываем её вместо шаблонной -->
  <div
    v-if="hasCmsContent"
    class="w-full max-w-(--ui-container) px-4 py-8 sm:m-auto sm:py-10"
  >
    <h1 class="mb-6 text-2xl font-bold">
      {{ item!.title }}
    </h1>
    <InfoCmsBody :item="item" :has-cms-content="hasCmsContent" />
  </div>

  <div v-else class="about-page">
    <section class="flex min-h-[70vh] items-center justify-center bg-black px-4 py-16 sm:min-h-[80vh]">
      <UIcon
        :name="brandIcons.logoLargeLight"
        :aria-label="brandInfo.name"
        class="mx-auto h-16 w-auto sm:h-20 md:h-24"
      />
    </section>

    <section class="w-full max-w-(--ui-container) px-4 py-10 sm:m-auto sm:py-14">
      <h1 class="sr-only">
        О бренде
      </h1>

      <div class="rounded-none border border-default bg-elevated/50 p-6 text-sm leading-7 text-toned sm:p-10 sm:text-base sm:leading-8">
        <p>
          {{ brandInfo.name }} — fashion-шаблон витрины Skuby. Здесь вы можете рассказать историю бренда,
          философию и то, что отличает ваши вещи от остальных.
        </p>

        <p class="mt-5">
          {{ brandInfo.description }}
          Замените этот текст на описание вашего бренда: материалы, производство, ценности
          и то, что вы вкладываете в каждую коллекцию.
        </p>

        <figure class="relative my-8 h-48 overflow-hidden sm:my-10 sm:h-72 md:h-96">
          <UiPicture
            src="catalog/brand/mainBanner.png"
            provider="ipx"
            variant="imageFull"
            :alt="`Коллекция ${brandInfo.name}`"
            sizes="100vw sm:100vw"
            class="absolute inset-0 h-full w-full"
          />
        </figure>

        <p>
          Контроль качества, внимание к деталям и честная посадка — основа, на которой строится
          доверие покупателя. Опишите здесь, как устроен ваш цикл производства и ухода за изделием.
        </p>

        <p class="mt-5">
          Если у вас есть вопросы о размерах, уходе или заказе — мы всегда на связи
          <template v-if="brandInfo.vkName">
            в
            <a
              class="text-primary hover:underline"
              :href="`https://vk.com/${brandInfo.vkName}`"
              target="_blank"
              rel="noopener noreferrer"
            >VK</a>
          </template>
          <template v-if="brandInfo.tgName">
            <template v-if="brandInfo.vkName">
              и
            </template>
            в
            <a
              class="text-primary hover:underline"
              :href="`https://t.me/${brandInfo.tgName}`"
              target="_blank"
              rel="noopener noreferrer"
            >Telegram</a>
          </template>
          или по почте
          <a class="text-primary hover:underline" :href="`mailto:${brandInfo.email}`">{{ brandInfo.email }}</a>.
        </p>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { brandInfo } from '#Brand/info'
import InfoCmsBody from '#Info/components/InfoCmsBody.vue'
import { useInfoCmsPage } from '#Info/composables/useInfoCmsPage'
import { infoCmsSlugs } from '#Info/constants/cmsPages'
import UiPicture from '~/app/components/Image/UiPicture.vue'
import { brandIcons } from '~/app/theme/brand'

defineOptions({
  name: 'InfoAboutPage',
})

const { item, hasCmsContent } = await useInfoCmsPage(infoCmsSlugs.about)

useContentSeo(item, {
  fallbackTitle: 'О бренде',
  fallbackDescription: `${brandInfo.name} — ${brandInfo.description} Узнайте историю бренда, философию и ценности.`,
})
</script>
